// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const articleActions = require('client-v2/common/models/article/actions')
const collectionActions = require('client-v2/common/models/collection/actions')
const interestActions = require('client-v2/common/models/interest/actions')
const userActions = require('client-v2/common/models/user/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
const routerActions = require('client-v2/common/state/router/actions')
// Sibling imports
const { defaultFeedActions } = require('./actions')
const createAppPromoCardSelectors = require('./app-promo-card-selectors')
const { defaultFeedSelectors } = require('./selectors')

module.exports = {
  createFeedSmartComponent,
  defaultFeedSmartComponent: createFeedSmartComponent(defaultFeedActions, defaultFeedSelectors)
}

function createFeedSmartComponent(feedActions, feedSelectors) {

  const appPromoCardSelectors = createAppPromoCardSelectors(feedSelectors)

  function mapStateToProps(state) {
    const { user } = state
    const items = appPromoCardSelectors.getDenormalizedItems(state)
    return {
      // Flags
      isMoreAvailable: feedSelectors.getIsNextPageAvailable(state),
      // Values
      items,
      selfUserId: user.loggedIn ? user.id : undefined
    }
  }

  function mapDispatchToProps(dispatch) {
    const { dispatchAction, dispatchAuthRequiredAction } = deferDispatch(dispatch)

    function showArticleProfileModal(options) {
      if (options.event && options.event.altKey) {
        return articleActions.navigateToArticleProfile(options)
      }
      return feedActions.showArticleProfileModal(options)
    }

    return {
      onArticleAddClick: dispatchAuthRequiredAction(
        articleActions.handleArticleAddAction,
        authModalActions.showSignup
      ),
      onArticleCardClick: dispatchAction(articleActions.navigateToArticleContent),
      onArticleCountClick: dispatchAction(showArticleProfileModal),
      onArticleDomainClick: dispatchAction(articleActions.navigateToArticleDomainSearch),
      onArticleEmbedDisclose: dispatchAction(articleActions.trackContentView),
      onArticleMoreClick: dispatchAuthRequiredAction(
        articleActions.showArticleActionsModal,
        authModalActions.showSignup
      ),
      onArticlePreviewClick: dispatchAction(showArticleProfileModal),
      onArticleSeen: dispatchAction(articleActions.trackGridView),
      onArticleShareClick: dispatchAction(articleActions.showArticleShareModal),
      onCollectionCardClick: dispatchAction(collectionActions.navigateToCollectionProfile),
      onCollectionPostCountClick: dispatchAction(collectionActions.navigateToCollectionProfilePosts),
      onCollectionShareClick: dispatchAction(collectionActions.showCollectionShareModal),
      onCollectionSubscribeClick: dispatchAuthRequiredAction(
        collectionActions.toggleFollowing,
        authModalActions.showSignup
      ),
      onCollectionSubscriberCountClick: dispatchAction(collectionActions.navigateToCollectionProfileSubscribers),
      onCollectionUserClick: dispatchAction(collectionActions.navigateToCollectionUserProfile),
      onInterestCardClick: dispatchAction(interestActions.navigateToInterestProfile),
      onInterestFollowClick: dispatchAuthRequiredAction(
        interestActions.toggleFollowing,
        authModalActions.showSignup
      ),
      onMoreClick: dispatchAction(feedActions.loadMore),
      onNavigate: dispatchAction(routerActions.navigate),
      onUserCardClick: dispatchAction(userActions.navigateToUserProfile),
      onUserFollowClick: dispatchAuthRequiredAction(
        userActions.toggleFollowing,
        authModalActions.showSignup
      ),
      onUserFollowerCountClick: dispatchAction(userActions.navigateToUserProfileFollowers)
    }
  }

  const defaultSmartComponent = (
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(
      withImmutableToJS(
        require('./component-dumb')
      )
    )
  )

  return {
    default: defaultSmartComponent,
    mapStateToProps,
    mapDispatchToProps
  }
}
